import { Controller } from "@hotwired/stimulus"
import Keyboard from "simple-keyboard"

const BASE_ROWS = [
  "1 2 3 4 5 6 7 8 9 0 \u00df",
  "q w e r t z u i o p \u00fc",
  "a s d f g h j k l \u00f6 \u00e4",
  "{shift} y x c v b n m {bksp}"
]

const SHIFT_ROWS = [
  "1 2 3 4 5 6 7 8 9 0 \u00df",
  "Q W E R T Z U I O P \u00dc",
  "A S D F G H J K L \u00d6 \u00c4",
  "{shift} Y X C V B N M {bksp}"
]

const LAYOUT = {
  default: [...BASE_ROWS, "@ {space} . - _"],
  shift: [...SHIFT_ROWS, "@ {space} . - _"]
}

export default class extends Controller {
  static targets = ["input", "container"]

  connect() {
    this.onPointerDown = this.onPointerDown.bind(this)
    this.onClick = this.onClick.bind(this)
    document.addEventListener("pointerdown", this.onPointerDown)
    document.addEventListener("click", this.onClick)
    this.activeInput = null
    this.pendingDismiss = false
    this.keyboard = new Keyboard(this.containerTarget, {
      onChange: (value) => this.onKeyboardChange(value),
      onKeyPress: (button) => this.onKeyPress(button),
      layout: LAYOUT,
      display: {
        "{bksp}": '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H9l-7-8 7-8z"/><line x1="15" y1="9" x2="11" y2="15"/><line x1="11" y1="9" x2="15" y2="15"/></svg>',
        "{space}": " ",
        "{shift}": '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 9h-5v7H9v-7H4l8-9z"/></svg>'
      },
      mergeDisplay: true,
      theme: "hg-theme-default hg-theme-kiosk",
      preventMouseDownDefault: true,
      stopMouseDownPropagation: true
    })
  }

  disconnect() {
    document.removeEventListener("pointerdown", this.onPointerDown)
    document.removeEventListener("click", this.onClick)
    this.keyboard.destroy()
    this.keyboard = null
    this.activeInput = null
  }

  onPointerDown(event) {
    if (!this.activeInput) return
    if (this.inputTargets.includes(event.target)) return
    if (this.containerTarget.contains(event.target)) return
    this.pendingDismiss = true
  }

  onClick() {
    if (!this.pendingDismiss) return
    this.pendingDismiss = false
    this.hideKeyboard()
  }

  onFocus(event) {
    this.activeInput = event.target
    this.keyboard.setInput(this.activeInput.value)
    this.keyboard.setOptions({ layoutName: "default" })
    this.element.classList.add("keyboard-active")
  }

  onKeyPress(button) {
    if (button === "{shift}") {
      const next = this.keyboard.options.layoutName === "default" ? "shift" : "default"
      this.keyboard.setOptions({ layoutName: next })
    }
  }

  onKeyboardChange(value) {
    if (!this.activeInput) return
    this.activeInput.value = value
    this.activeInput.dispatchEvent(new Event("input", { bubbles: true }))

    if (this.keyboard.options.layoutName === "shift") {
      this.keyboard.setOptions({ layoutName: "default" })
    }
  }

  hideKeyboard() {
    if (this.activeInput) {
      this.activeInput.blur()
    }
    this.activeInput = null
    this.element.classList.remove("keyboard-active")
  }
}
